"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ContractBase_1 = __importDefault(require("./ContractBase"));
var utils_1 = require("../../utils");
var DIDRegistry = (function (_super) {
    __extends(DIDRegistry, _super);
    function DIDRegistry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DIDRegistry.getInstance = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var didRegistry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        didRegistry = new DIDRegistry('DIDRegistry');
                        return [4, didRegistry.init(config)];
                    case 1:
                        _a.sent();
                        return [2, didRegistry];
                }
            });
        });
    };
    DIDRegistry.prototype.registerAttribute = function (did, checksum, providers, value, ownerAddress) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.send('registerAttribute', ownerAddress, [
                        utils_1.zeroX(did),
                        utils_1.zeroX(checksum),
                        providers.map(utils_1.zeroX),
                        value
                    ])];
            });
        });
    };
    DIDRegistry.prototype.getDIDOwner = function (did) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.call('getDIDOwner', [utils_1.didZeroX(did)])];
            });
        });
    };
    DIDRegistry.prototype.getBlockNumberUpdated = function (did) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.call('getBlockNumberUpdated', [utils_1.zeroX(did)])];
                    case 1: return [2, +(_a.sent())];
                }
            });
        });
    };
    DIDRegistry.prototype.isDIDProvider = function (did, provider) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.call('isDIDProvider', [utils_1.didZeroX(did), utils_1.zeroX(provider)])];
            });
        });
    };
    DIDRegistry.prototype.getDIDProviders = function (did) {
        return __awaiter(this, void 0, void 0, function () {
            var providers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.call('getDIDRegister', [utils_1.didZeroX(did)])];
                    case 1:
                        providers = (_a.sent()).providers;
                        return [2, providers];
                }
            });
        });
    };
    DIDRegistry.prototype.getAttributesByOwner = function (owner) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getPastEvents('DIDAttributeRegistered', {
                            _owner: utils_1.zeroX(owner)
                        })];
                    case 1: return [2, (_a.sent())
                            .map(function (_a) {
                            var returnValues = _a.returnValues;
                            return returnValues._did;
                        })
                            .map(utils_1.didPrefixed)];
                }
            });
        });
    };
    DIDRegistry.prototype.getAttributesByDid = function (did) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getPastEvents('DIDAttributeRegistered', {
                            _did: utils_1.didZeroX(did)
                        })];
                    case 1: return [2, (_a.sent()).map(function (_a) {
                            var _b = _a.returnValues, _did = _b._did, checksum = _b._checksum, serviceEndpoint = _b._value;
                            return ({
                                did: utils_1.didPrefixed(_did),
                                serviceEndpoint: serviceEndpoint,
                                checksum: checksum
                            });
                        })[0]];
                }
            });
        });
    };
    DIDRegistry.prototype.grantPermission = function (did, grantee, ownerAddress) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.send('grantPermission', ownerAddress, [utils_1.didZeroX(did), utils_1.zeroX(grantee)])];
            });
        });
    };
    DIDRegistry.prototype.revokePermission = function (did, grantee, ownerAddress) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.send('revokePermission', ownerAddress, [
                        utils_1.didZeroX(did),
                        utils_1.zeroX(grantee)
                    ])];
            });
        });
    };
    DIDRegistry.prototype.getPermission = function (did, grantee) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.call('getPermission', [utils_1.didZeroX(did), utils_1.zeroX(grantee)])];
            });
        });
    };
    DIDRegistry.prototype.transferDIDOwnership = function (did, newOwnerAddress, ownerAddress) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.send('transferDIDOwnership', ownerAddress, [
                        utils_1.didZeroX(did),
                        utils_1.noZeroX(newOwnerAddress)
                    ])];
            });
        });
    };
    return DIDRegistry;
}(ContractBase_1.default));
exports.default = DIDRegistry;
//# sourceMappingURL=DIDRegistry.js.map